import {createSlice} from "@reduxjs/toolkit"

const cartSlice=createSlice({
    name:"cart",
    initialState:{
        products:[],
        quantity:0,
        totalPrice:0
    },
    reducers:{
        addProduct:(state,action)=>{
           const {quantity,price}=action.payload
            state.quantity+=1;
            state.products.push(action.payload);
            state.totalPrice+=quantity*price;
        },
        logoutProduct:(state)=>{
             state.quantity=0;
             state.products=[];
             state.totalPrice=0;
             window.localStorage.clear();
         }
    }
})

export const {addProduct,logoutProduct}=cartSlice.actions
export default cartSlice.reducer;
export const quantitySelector=state=>state.cart.quantity;
export const productsSelector=state=>state.cart.products;
export const totalpriceSelector=state=>state.cart.totalPrice;